<template>
  <div class="loglist">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="Refresh"
      @search="onHandleSearch"
    >
      <template v-slot:right>
        <el-button
          @click="onHandleExport"
          type="warning"
          icon="el-icon-upload2"
          :disabled="disabledExport || !tableData.length"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <!-- 列表 start -->
    <div class="content-wrap">
      <el-table
        v-loading="loadingData"
        ref="costReviewTable"
        :data="tableData"
        height="100%"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column
          prop="original_logistics_name"
          align="center"
          label="迁移前城市仓"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="new_logistics_name"
          align="center"
          label="迁移后城市仓"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="logistic_business_name"
          align="center"
          label="集配中心（迁移后）"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="member_name"
          align="center"
          label="客户姓名"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="mobile"
          align="center"
          label="客户电话"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="create_time"
          align="center"
          label="迁移时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="op_name"
          align="center"
          label="操作人"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import cloneDeep from "lodash/cloneDeep";
import { postRegionalManagerSelectList } from "@/api/general/manager.js";
import { memberlogsexport } from "@/api/export/index.js";
import { downLoadFlowBlob } from "@/utils/tools/base";
export default {
  name: "city-insurance-entry",
  components: { Filtersearch },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "select",
          name: "迁移前仓名",
          clearable: true,
          filterable: true,
          // multiple: true,
          model: "original_logistics_id",
          placeholder: "请选择迁移前仓名",
          label: "name",
          value: "id",
          selectoptionname: "cityList",
          selectoption: [],
        },
        {
          type: "select",
          name: "迁移后仓名",
          clearable: true,
          filterable: true,
          // multiple: true,
          model: "new_logistics_id",
          placeholder: "请选择迁移后仓名",
          label: "name",
          value: "id",
          selectoptionname: "cityList",
          selectoption: [],
        },

        {
          type: "input",
          name: "用户姓名",
          clearable: true,
          model: "member_name",
          placeholder: "用户姓名",
        },
        {
          type: "input",
          name: "用户电话",
          clearable: true,
          model: "mobile",
          placeholder: "用户电话",
        },

        {
          type: "select",
          name: "集配中心",
          clearable: true,
          model: "logistic_business_id",
          placeholder: "请选择集配中心",
          selectoptionname: "logisticsList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "区域经理",
          clearable: true,
          model: "regional_manager_id",
          placeholder: "请选择区域经理",
          selectoptionname: "managerList",
          label: "fullname",
          value: "id",
          selectoption: [],
        },

        {
          type: "daterange",
          name: "迁移时间",
          clearable: true,
          model: "time",
          startmodel: "start_time",
          endmodel: "end_time",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
        },
      ],

      total: 0,
      loadingData: false,
      disabledExport: false,
      formData: {
        original_logistics_id: "", //	number	迁移前仓id
        new_logistics_id: "", //	number	迁移后仓id
        mobile: "", //	string	用户手机号
        member_name: "", //	string	用户姓名
        logistic_business_id: "", //	string	集配中心id
        start_time: "", //	string	开始日期
        end_time: "", //	string	结束日期
        regional_manager_id: "", //	number	区域经理id
        page: 1,
        pageSize: 50,
      },
      formDataClone: {}, // 复制数据，用于初始化
      tableData: [], //列表数据
      logisticsList: [], // 集配中心列表
      cityList: [], // 城市仓列表
    };
  },
  created() {
    this.formDataClone = cloneDeep(this.formData);
    this.initData();
  },
  methods: {
    // 获取城市仓列表
    async citylist() {
      try {
        const res = await this.$api.Followup.logisticsselect({
          name: "",
          page: 1,
          pageSize: 1000,
        });
        console.log(res, "res");
        this.cityList = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "cityList"
          ) {
            el.selectoption = [
              { id: "", name: "全部" },
              ...res.data,
            ];
          }
        });
      } catch (error) {
        console.log(error, "logisticsList");
      }
    },
    // 区域经理下拉
    async postAjaxRegionalManagerSelectList() {
      try {
        const res = await postRegionalManagerSelectList();
        console.log(res, "res==");
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "managerList"
          ) {
            el.selectoption = [...res.data];
          }
        });

        console.log(this.Filtersearchlist, "333");
      } catch (error) {
        console.log(error, "postRegionalManagerSelectList");
      }
    },
    /**
     * 获取集配中心列表
     */
    async getAjaxLogisticsList() {
      try {
        const { data } = await this.$api.general.businessList({
          is_online: 1, // 启用中
        });
        this.logisticsList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "logisticsList"
          ) {
            el.selectoption = [{ area_code: "", name: "全部" }, ...data];
          }
        });
        console.log("ajax getAjaxLogisticsList", data);
      } catch (err) {
        console.log("ajax getAjaxLogisticsList err", err);
      }
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.hqlist();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.hqlist();
    },
    /**
     * 查询
     */
    onHandleSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.hqlist();
    },
    /**
     * 初始化数据
     */
    initData() {
      this.getAjaxLogisticsList();
      this.postAjaxRegionalManagerSelectList();
      this.citylist();
      this.hqlist();
    },
    /**
     * 列表数据
     */
    async hqlist() {
      try {
        this.loadingData = true;
        this.$api.product.memberlogs(this.formData).then((res) => {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.loadingData = false;
        });
      } catch (error) {
        this.loadingData = false;
        console.log(error, "postLogisticsPremiumsSettlementList");
      } finally {
      }
    },

    /**
     * 重置数据
     */
    Refresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.hqlist();
    },

    /**
     * 导出逻辑
     */
    async onHandleExport() {
       this.disabledExport = true;
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;

        const res = await memberlogsexport(query);
        downLoadFlowBlob(res, res?.filename);
      } catch (err) {
        this.$message.error("导出失败了");
        console.log("ajax memberlogsexport err", err);
        console.log("ajax memberlogsexport err", err);
      } finally {
        this.disabledExport = false;
      }
    },
    // /**
    //  * 导出逻辑
    //  */
    // async onHandleExport() {
    //   this.disabledExport = true;
    //   try {
    //     const query = {
    //       ...this.formData,
    //       token: sessionStorage.getItem("token"),
    //     };
    //     delete query.page;
    //     delete query.pageSize;
    //     await memberlogsexport(query);
    //     this.goExportCenter();
    //   } catch (err) {
    //     console.log("ajax memberlogsexport err", err);
    //     this.disabledExport = false;
    //   }
    // },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.loglist {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;

  .content-wrap {
    flex: 1;
    overflow-y: hidden;
  }
  .pagination {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
